export function IconDownChevron({ active }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: active ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 0.3s ease-in-out', // Adjust duration and easing as needed
      }}
    >
      <mask
        id="mask0_453_4132"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_453_4132)">
        <path
          d="M10 12.8333L5 7.83333L6.16667 6.66667L10 10.5L13.8333 6.66667L15 7.83333L10 12.8333Z"
          fill="#006FCF"
        />
      </g>
    </svg>
  );
}
